<template>
    <div v-if="show" ref="cardRef" class="top-banner d-flex p-5 shadow justify-content-between align-items-center">
      <div class="d-flex justify-content-between align-items-center">
        <div class="symbol symbol-80px w-50px bg-light">
          <img :src="img" alt="image" class="p-3">
        </div>
        <div class="mx-3">
          <h4 class="text-uppercase">{{tenant}} </h4>
          <p class="fs-4">{{ $t('pwa.desc') }}</p>
        </div>
      </div>
      <button class="btn btn-md btn-primary m-3" @click="installApp">{{ $t("pwa.install") }}</button>
    </div>
</template>
<script setup>
import { onBeforeUnmount, ref, watch, watchEffect } from 'vue';
import { onMounted } from 'vue';
import {getImagePath, getTenantId} from '../mixins/Helpers';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const show = ref(false)
const cardRef = ref(null)
const INSTALL_KEY = 'pwa-install-choice'

const img = ref('/pwa-192x192.png'); // valeur par défaut

const tenant = computed(() => {
  return getTenantId()?.slice(0, -1) ?? ''
})

watch(route, () => {
    fetchIcon();
});

const fetchIcon = async () => {
  const tenantId = getTenantId()?.slice(0, -1);
  const iconHref = `/assets/media/${tenantId}/pwa-192x192.png`;

  try {
    const res = await fetch(iconHref, { method: 'HEAD' });
    if (res.ok) {
      img.value = iconHref;
    } else {
      img.value = '/pwa-192x192.png';
    }
  } catch (error) {
    img.value = '/pwa-192x192.png';
  }
};

const isStandalone = () => {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
}

const installApp = async () => {
  if ( window.deferredPrompt) {
    window.deferredPrompt.prompt();
    const { outcome } = await  window.deferredPrompt.userChoice;
    localStorage.setItem(INSTALL_KEY, outcome)

    if (outcome === 'accepted') {
      show.value = false;
      window.deferredPrompt = null;
    }
  }
};


const dismiss = () => {
  localStorage.setItem(INSTALL_KEY, 'dismissed')
  show.value = false
}

function handleClickOutside(event) {
  if (cardRef.value && !cardRef.value.contains(event.target)) {
   dismiss()
  }
}
   
onMounted(() => {
  fetchIcon()
  const choice = localStorage.getItem(INSTALL_KEY)
  if (isStandalone() || choice === 'accepted' || choice === 'dismissed') {
    return
  }

  window.addEventListener('beforeinstallprompt', (e) => {
     show.value = true
    e.preventDefault();
    window.deferredPrompt = e
  });

  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

</script>
<style>
.top-banner{
    position: fixed;
    width: 30%;
    bottom: 20px;
    right: 20px;
    background-color: white;
    height: 12%;
    z-index: 100;
    border-radius:10px;
}
</style>